import React, {
    useEffect, useRef, useState 
} from 'react';
import {
    Box 
} from '@mui/material';
import dynamic from 'next/dynamic';

const Lottie = dynamic(() => import('lottie-react'), {
    ssr: false
});

type Props = {
    fileName: string,
    segments: { frames: number[] }[],
    delay?: number,
    loop?: boolean,
    lottieStyles?: React.CSSProperties
}

export const LottieAnimation = ({
    fileName, segments, delay = 0, loop = false, lottieStyles
}: Props): JSX.Element => {

    const lottieRef = useRef();
    const [animation, setAnimation] = useState(null);
    const [currentSegment, setCurrentSegment] = useState(0);

    const onDOMLoaded = () => {
        setTimeout(() => {
            playSegement(0);
        }, delay);
    };

    const playSegement = (segmentIndex: number) => {
        setCurrentSegment(segmentIndex);
        const segment = segments[0];

        const ref = lottieRef.current || {};
        ref['playSegments'](segment.frames, true);
    };

    const onComplete = () => {
        const segment = segments[currentSegment + 1];
        if (segment) playSegement(currentSegment + 1);
    };

    useEffect(() => {
        import(`./lottie/${fileName}`).then((animation) => {
            setAnimation(animation.default);
        });
    }, [lottieRef]);

    return (
        <Box
            style={{
                width: '100%',
                height: '100%' 
            }}
        >
            <Lottie
                height={''}
                lottieRef={lottieRef}
                autoplay={false}
                animationData={animation}
                loop={loop}
                onDOMLoaded={onDOMLoaded}
                onComplete={onComplete}
                style={lottieStyles}
            />
        </Box>
    );
};

export default LottieAnimation;
